<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/solutions/cloud">Cloud</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Data Center Modernization
              </li>
            </ol>
          </nav>

          <div class="row">
            <div class="col-lg-8">
              <h2 class="title">Data Center Modernization</h2>

              <h3 class="title  pt-2"></h3>
              <p class="lead">
                It is the goal of every corporate company and individual
                companies to deliver computing capabilities that match their
                exact business requirements and maximize ROI. In many cases,
                multiple or parallel investments lead to server sprawl and low
                server utilization rates. Improperly- planned Data Center
                strategies can lead to user complaints about poor computing
                performance, and even worse, the lack of a high availability
                solution should a disaster strike the business.
              </p>
              <p class="lead">
                Our company offers advanced Data Center modernization solutions
                designed by technology architects, engineers and developers with
                deep engineering expertise:
              </p>

              <H3>Storage</H3>
              <p class="lead">
                Manage data while maximizing application performance and
                preparing for the growth of business processes, applications and
                underlying infrastructure.
              </p>

              <H3>Unified Computing</H3>
              <p class="lead">
                Unite computing, networking, storage access and virtualization
                by integrating low-latency network fabric with enterprise
                servers.
              </p>
              <H3>Virtualization</H3>
              <p class="lead">
                Improve component efficiency and availability to ensure
                effective business operations while reducing energy bills by
                consolidating servers.
              </p>

              <h3>Backup and Recovery</h3>
              <p class="lead">
                Protect data through secure and encrypted methods and limit
                access to employees with the appropriate permissions.
              </p>

              <h3>Data Center Networking</h3>
              <p class="lead">
                Realize the benefits of high performance and advanced
                next-generation data center network architectures.
              </p>
              <h3>Private Cloud</h3>
              <p class="lead">
                Create a converged infrastructure with scalable and tailored
                technologies ensuring data security and regulatory compliance.
              </p>
            </div>

            <div class="col-lg-4">
              <CloudSideNav></CloudSideNav>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import CloudSideNav from "./CloudSideNav";
export default {
  name: "cloud overview",
  components: {
    CloudSideNav,
  },
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
